module.exports = __webpack_public_path__ + "static/img/0401_04.1c4164e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0401_04.png
// module id = wuk1
// module chunks = 1